import type { KeyStats } from "@/api/sourceData.service";
import type { SourceDataOutcome } from "./sourceDataOutcome";
import { DASH } from "./dash";

export type KeyStatCell = { caption: string; tooltip: string; value: string; check: boolean };

export type KeyStatsView =
  | { kind: "loading" }
  | { kind: "error"; message: string }
  | { kind: "stats"; cells: KeyStatCell[]; note: string | null };

export const KEY_STATS_ERROR = "Key stats could not be loaded. Try again shortly.";

function cells(stats: KeyStats | null): KeyStatCell[] {
  const count = (value: number | null | undefined) => (value == null ? DASH : String(value));
  const submitted = stats?.submitted;
  return [
    {
      caption: "Submitted to this BPA",
      tooltip: "Firm submitted to this BPA",
      value: submitted == null ? DASH : submitted ? "Yes" : "No",
      check: submitted === true,
    },
    {
      caption: "Referees submitted",
      tooltip: "Number of referees submitted",
      value: count(stats?.refereesSubmitted),
      check: false,
    },
    {
      caption: "Referees responded",
      tooltip: "Number of referees responded",
      value: count(stats?.refereesResponded),
      check: false,
    },
  ];
}

/** The bar's three cells with no values yet, so the loading bar keeps the loaded bar's layout. */
export const LOADING_CELLS: KeyStatCell[] = cells(null).map(cell => ({
  ...cell,
  value: "",
  check: false,
}));

export function keyStatsView(outcome: SourceDataOutcome<KeyStats>): KeyStatsView {
  switch (outcome.kind) {
    case "loading":
      return { kind: "loading" };
    case "error":
      return { kind: "error", message: KEY_STATS_ERROR };
    case "unknown":
      return { kind: "stats", cells: cells(null), note: outcome.sentence };
    case "empty":
      return { kind: "stats", cells: cells(null), note: null };
    case "data":
      return { kind: "stats", cells: cells(outcome.data), note: null };
  }
}
